import React, { Component } from "react"
import {
  Carousel,
  CarouselItem,
  CarouselControl,
  CarouselIndicators,
  CarouselCaption,
  Card,
  CardBody,
} from "reactstrap"

// Carousel images
import img3 from "../../../assets/images/small/slider_1.webp"
import img4 from "../../../assets/images/small/slider_2.webp"
import img5 from "../../../assets/images/small/slider_3.jpg"

const items = [
  {
    src: img3,
    altText: "A fun day at the park with my child.",
    caption: "Park Adventures",
  },
  {
    src: img4,
    altText: "Exploring the zoo and seeing animals.",
    caption: "Zoo Exploration",
  },
  {
    src: img5,
    altText: "Enjoying a sunny day at the beach.",
    caption: "Beach Fun",
  },
];


class Slidewithcaption extends Component {
  constructor(props) {
    super(props)
    this.state = { activeIndex: 0 }
    this.next = this.next.bind(this)
    this.previous = this.previous.bind(this)
    this.goToIndex = this.goToIndex.bind(this)
    this.onExiting = this.onExiting.bind(this)
    this.onExited = this.onExited.bind(this)
  }

  onExiting() {
    this.animating = true
  }

  onExited() {
    this.animating = false
  }

  next() {
    if (this.animating) return
    const nextIndex =
      this.state.activeIndex === items.length - 1
        ? 0
        : this.state.activeIndex + 1
    this.setState({ activeIndex: nextIndex })
  }

  previous() {
    if (this.animating) return
    const nextIndex =
      this.state.activeIndex === 0
        ? items.length - 1
        : this.state.activeIndex - 1
    this.setState({ activeIndex: nextIndex })
  }

  goToIndex(newIndex) {
    if (this.animating) return
    this.setState({ activeIndex: newIndex })
  }

  render() {
    const { activeIndex } = this.state

    const slides = items.map(item => {
      return (
        <CarouselItem
          onExiting={this.onExiting}
          onExited={this.onExited}
          key={item.src}
        >
          <img
            src={item.src}
            className="d-block img-fluid"
            alt={item.altText}
            style={{ height: '480px', objectFit: 'cover' ,padding:'4px'}}
          />
          <CarouselCaption
            captionText={item.altText}
            captionHeader={item.caption}
          />
        </CarouselItem>
      )
    })

    return (
      <React.Fragment>
        {/* <div    style={{  height: '550px' }}> */}
        {/* <CardBody> */}
        <Carousel
          activeIndex={activeIndex}
          next={this.next}
          previous={this.previous}
          className="h-100"
        >
          {/* <CarouselIndicators
            items={items}
            activeIndex={activeIndex}
            onClickHandler={this.goToIndex}
          /> */}
          {slides}
          <CarouselControl
            direction="prev"
            directionText="Previous"
            onClickHandler={this.previous}
          />
          <CarouselControl
            direction="next"
            directionText="Next"
            onClickHandler={this.next}
          />
        </Carousel>
        {/* </CardBody> */}
        {/* </div> */}
      </React.Fragment>
    )
  }
}

export default Slidewithcaption
